import { ComponentPropsWithoutRef, forwardRef } from "react"
import { Button } from "@components/atoms/Button"
import { CARET_LEFT, CARET_RIGHT, ELLIPSIS } from "@components/atoms/Icons"
import { cn } from "@utils/tw"
import { ArticleCardFragment, DocumentCardFragment, SearchPageFragment } from "../../../types.graphql"

export const Pagination = ({
  pages,
  currentPage,
  setCurrentPage,
}: {
  pages: (string | null | (SearchPageFragment | ArticleCardFragment | DocumentCardFragment | null)[])[]
  currentPage: number
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>
}) => {
  return (
    <PaginationContainer>
      <div>
        <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
          {CARET_LEFT}
        </Button>
      </div>

      {pages.length > 4 ? (
        <div>
          {currentPage === 1 && (
            <>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 2)}>
                {currentPage + 2}
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(pages.length)}>
                {pages.length}
              </Button>
            </>
          )}

          {currentPage === 2 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(pages.length)}>
                {pages.length}
              </Button>
            </>
          )}

          {currentPage === 3 && pages.length !== 5 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 2)}>
                {currentPage - 2}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(pages.length)}>
                {pages.length}
              </Button>
            </>
          )}

          {![1, 2, 3, pages.length - 2, pages.length - 1, pages.length].includes(currentPage) && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(1)}>
                1
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(pages.length)}>
                {pages.length}
              </Button>
            </>
          )}

          {currentPage === pages.length - 2 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(1)}>
                1
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 2}
              </Button>
            </>
          )}

          {currentPage === pages.length - 1 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(1)}>
                1
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
            </>
          )}

          {currentPage === pages.length && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(1)}>
                1
              </Button>
              {ELLIPSIS}
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 2)}>
                {currentPage - 2}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
            </>
          )}
        </div>
      ) : (
        <div>
          {currentPage === 1 && (
            <>
              <FalseButton>{currentPage}</FalseButton>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                {currentPage + 1}
              </Button>
              {pages.length > 2 && (
                <>
                  <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 2)}>
                    {currentPage + 2}
                  </Button>
                  {pages.length > 3 && (
                    <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 3)}>
                      {currentPage + 3}
                    </Button>
                  )}
                </>
              )}
            </>
          )}

          {currentPage === 2 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              {pages.length > 2 && (
                <>
                  <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                    {currentPage + 1}
                  </Button>
                  {pages.length > 3 && (
                    <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 2)}>
                      {currentPage + 2}
                    </Button>
                  )}
                </>
              )}
            </>
          )}

          {currentPage === 3 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 2)}>
                {currentPage - 2}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
              {pages.length > 3 && (
                <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage + 1)}>
                  {currentPage + 1}
                </Button>
              )}
            </>
          )}

          {currentPage === 4 && (
            <>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 3)}>
                {currentPage - 3}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 2)}>
                {currentPage - 2}
              </Button>
              <Button size="small" color="grey" onClick={() => setCurrentPage(currentPage - 1)}>
                {currentPage - 1}
              </Button>
              <FalseButton>{currentPage}</FalseButton>
            </>
          )}
        </div>
      )}

      <div>
        <Button
          size="small"
          color="grey"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === pages.length}
        >
          {CARET_RIGHT}
        </Button>
      </div>
    </PaginationContainer>
  )
}

const PaginationContainer = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "w-full bg-light-grey rounded-md p-2 my-7 flex justify-between gap-3",
        "[&>div]:min-w-[32px]",
        "[&>div:nth-of-type(2)]:flex [&>div:nth-of-type(2)]:items-center [&>div:nth-of-type(2)]:gap-3",
        "[&_button]:w-[32px] [&_button]:h-[32px] [&_button]:min-w-[32px] [&_button]:min-h-[32px]",
        "[&_a]:w-[32px] [&_a]:h-[32px] [&_a]:min-w-[32px] [&_a]:min-h-[32px]",
        "[&_button_svg]:scale-150 [&_a_svg]:scale-150",
        "lg:[&_button_svg]:scale-[3] lg:[&_a_svg]:scale-[3]",
        className,
      )}
      {...props}
    />
  ),
)
PaginationContainer.displayName = "PaginationContainer"

const FalseButton = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "w-[32px] h-[32px] min-w-[32px] min-h-[32px] flex items-center justify-center",
      "text-white bg-black rounded-[6px] type-label-s",
      className,
    )}
    {...props}
  />
))
FalseButton.displayName = "FalseButton"
